import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { BASE_URL, requestOptionsGET } from "../../../utils/Constants"
import { useAuth } from "../../../utils/context/AuthContext"

const WallPage = () => {
  const { auth } = useAuth()
    const idToken = auth.idToken
    const userId = auth.userId

  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    callGetMedicalUserApi()
  }, [])

  // GET users info by user_id
  async function callGetMedicalUserApi() {
    if (!idToken || !userId) return
    setIsLoading(true)
    const responseUserinfo = await fetch(`${BASE_URL}/api/medical-user/${userId}`, requestOptionsGET(idToken))
    setIsLoading(false)
    if (responseUserinfo.ok) {
      const responseJson = await responseUserinfo.json()
      console.log(responseJson)
      if (responseJson.calendly_data.calendly_invitation_status !== "pending") {
        navigate("/platform-experts")
      }
    } else if (responseUserinfo.status === 401) {
      // call refreshToken
      navigate("/login")
    } else {
      const responseJson = await responseUserinfo.json()
      console.log(responseJson)
    }
  }

  async function callSyncCalendlyApi() {
    setIsLoading(true)
    const responseUserinfo = await fetch(`${BASE_URL}/api/medical-user/sync-calendly/${userId}`, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': idToken!,
      },
    })
    setIsLoading(false)
    if (responseUserinfo.ok) {
      const responseJson = await responseUserinfo.json()
      if (responseJson.calendly_data.calendly_invitation_status !== "pending") {
        navigate("/platform-experts", { state: { userId, idToken } })
      }
    } else {
      const responseInfoJson = await responseUserinfo.json()
      console.log(responseInfoJson)
    }
  }

  return (
    <div className="App">
      <div className="w-full h-full flex items-start justify-center overflow-y-auto">
        <div className="w-full h-full flex flex-col items-center justify-center bg-white">
          <div className="w-full h-[80%] flex flex-col items-center justify-between">
            <div>
              <img src="/images/holifyaLogos/holifya-logo-blue.svg" />
            </div>
            <div className="font-bold text-[30px] leading-[40px]">
              Fantastico!
            </div>
            <div className="font-normal text-[18px] leading-[26px]">
              Hai ricevuto una mail con l'invito a connetterti al nostro Calendly.
              Prosegui da lì per selezionare le tue disponibilità.
            </div>
            <div className="w-[80%] h-[375px] flex items-center justify-center bg-[url('/public/images/flow-image.svg')] bg-contain bg-no-repeat bg-center" />
            <button
              className="w-[328px] h-[55px] cursor-pointer leading-[17px] border-none rounded-[5px] text-white font-bold text-[14px] uppercase primary-action-color-background"
              onClick={callSyncCalendlyApi}
            >
              Registrazione effettuata
            </button>
            <div className="font-normal text-[18px] leading-[26px]">
              Una volta che avrai settato il tuo account collegato Calendly avrai accesso alla tua area personale Holifya.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WallPage
